"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditLabelDialog = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_query_1 = require("@tanstack/react-query");
const react_1 = tslib_1.__importDefault(require("react"));
const useVisibilitySelection_1 = require("../hooks/useVisibilitySelection");
const useCustomNameValidation_1 = require("./hook/useCustomNameValidation");
const LabelHelpers_1 = require("./LabelHelpers");
const NewCategoryExperience_1 = require("./NewCategoryExperience");
const labelValues_1 = require("./restApi/labelValues");
const LabelType_1 = require("./shared/LabelType");
const Styles_1 = require("./Styles");
const editLabelTestId = 'Edit-Label';
const queryKey = [editLabelTestId];
function EditLabelDialog(_a) {
    var { close, dismiss } = _a, props = tslib_1.__rest(_a, ["close", "dismiss"]);
    const initialLabelValueName = props.labelValueName;
    const customTextValidation = (0, useCustomNameValidation_1.useCustomNameValidation)(queryKey, catalog_messages_1.Messages.LabelValueAlreadyExists(), labelValues_1.getLabelValues, initialLabelValueName);
    const queryClient = (0, react_query_1.useQueryClient)();
    const hideDialog = react_1.default.useCallback(() => {
        dismiss();
    }, [dismiss]);
    const mutationFn = (0, catalog_core_1.useRestFn)(labelValues_1.updateLabelValue);
    const submit = (0, react_query_1.useMutation)({
        mutationFn,
        onSettled: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield queryClient.invalidateQueries({ queryKey });
            hideDialog();
        }),
        onSuccess: ({ category, name }) => widgets_1.ToastWidget.show({
            message: catalog_messages_1.Messages.LabelValueUpdated({
                Category: (0, LabelHelpers_1.localizeLabelCategory)(category),
                name: (0, LabelType_1.localizeLabelValueName)(name),
            }),
            toastType: widgets_1.ToastType.Success,
            testId: 'edit-label-success',
        }),
        onError: () => {
            widgets_1.ToastWidget.show({
                message: catalog_messages_1.Messages.ErrorWithoutErrorCode(),
                toastType: widgets_1.ToastType.Error,
                testId: 'edit-category-error',
            });
        },
    });
    const [category, CategoryDropdown] = (0, NewCategoryExperience_1.useCategoryDropdown)(true, props.categoryName);
    const { value: labelValueName, valid: nameValid, element: NameWidget } = (0, catalog_core_1.useTextField)({
        initialState: initialLabelValueName,
        label: catalog_messages_1.Messages.LabelValue(),
        testId: editLabelTestId,
        max: 24,
        style: { width: 200 },
        disabled: submit.isLoading,
        customTextValidation: submit.isLoading ? undefined : customTextValidation,
    });
    const { value: description, valid: descriptionValid, element: DescriptionWidget } = (0, catalog_core_1.useTextFormatter)({
        initialState: props.description,
        label: catalog_messages_1.Messages.LabelDescription(),
        testId: editLabelTestId,
        max: 500,
        disabled: submit.isLoading,
        style: {},
    });
    const { elevatedDefault, element: SelectionWidget } = (0, useVisibilitySelection_1.useVisibilitySelection)(category, props.elevatedDefault, true);
    const submitDisabled = submit.isLoading
        || category.length < 1
        || labelValueName.trim().length < 1
        || nameValid !== undefined
        || description.length < 1
        || descriptionValid !== undefined;
    const footerContent = (react_1.default.createElement("div", { className: Styles_1.FooterButtonsStyle },
        react_1.default.createElement("div", { style: { flex: 1 } }),
        react_1.default.createElement(widgets_1.ButtonWidget, { disabled: submit.isLoading, onClick: hideDialog }, catalog_messages_1.Messages.Cancel()),
        react_1.default.createElement(widgets_1.ButtonWidget, { disabled: submitDisabled, showSpinner: submit.isLoading, onClick: () => submit.mutate({
                labelValue: {
                    category,
                    name: labelValueName.trim(),
                    description,
                    elevatedDefault: elevatedDefault !== null && elevatedDefault !== void 0 ? elevatedDefault : undefined,
                },
                name: initialLabelValueName,
            }), buttonType: widgets_1.ButtonType.Primary }, catalog_messages_1.Messages.Save())));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widgets_1.DialogWidget, { testId: editLabelTestId, isModal: true, showCloseButton: true, isGlassTransparent: false, shouldReturnFocusOnClose: true, onCloseRequest: hideDialog, handleGlassClick: hideDialog, type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Draggable, dialogWidth: 900, title: catalog_messages_1.Messages.EditLabelButton(), footerContent: footerContent, disableAutoFocus: props.builtIn },
            react_1.default.createElement("div", { style: { borderRight: 2, display: 'flex' } },
                react_1.default.createElement("div", { style: { flex: 1, paddingRight: 16, borderRight: `1px solid #E6E6E6` } }, CategoryDropdown),
                react_1.default.createElement("div", { style: { flex: 2, paddingLeft: 16 } },
                    NameWidget,
                    DescriptionWidget,
                    SelectionWidget)))));
}
exports.EditLabelDialog = EditLabelDialog;
//# sourceMappingURL=EditLabelExperience.js.map